const FEATURE_FLAGS = {
  AI_AUTOMATION: "ai_and_automation",
  LEAD_MANAGEMENT: "lead_management",
  SCHEDULER: "scheduler",
  DEAL_MANAGER: "deal_manager",
  CALL_TRACKING: "call_tracking",
  LEAD_GENERATION: "lead_generation",
}

export default FEATURE_FLAGS
